<div class="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 text-center">
  <div class="max-w-md rounded-2xl bg-white p-8 shadow-md">
    <h1 class="mb-4 text-3xl font-semibold text-red-600">Tenant Inactive</h1>
    <p class="mb-6 text-gray-600">
      The tenant you are trying to access is inactive.<br />
      Please contact your administrator for assistance.
    </p>
    <button
      class="mt-2 rounded-lg bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700"
      (click)="goToHome()"
    >
      Go to Home
    </button>
  </div>
</div>
